import React from 'react';
import { useQuery, gql } from '@apollo/client';

import withApollo from 'data/with-apollo';
import PageLayout from 'components/page-layout';
import TornSection from 'components/torn-section';
import PageContainer from 'components/page-container';
import PageTitle from 'components/page-title';
import Tiles from 'components/tiles';
import ArtistTile from 'components/artist-tile';

const GET_ARTISTS = gql`
  query {
    portfolioEntries(
      where: {
        orderby: [{ field: TITLE, order: ASC }]
        taxQuery: {
          relation: OR
          taxArray: [{ terms: ["bhr"], taxonomy: SITE, operator: IN, field: SLUG }]
        }
      }
    ) {
      nodes {
        title
        slug
        featuredImage {
          sourceUrl
        }
      }
    }
  }
`;

const ArtistsPage = () => {
  const { data, loading } = useQuery(GET_ARTISTS);
  const artists = data?.portfolioEntries.nodes ?? [];

  if (!artists.length && loading) return null;

  return (
    <PageLayout>
      <TornSection as="main" className="my-12 lg:my-24">
        <PageContainer>
          <PageTitle>Artists</PageTitle>

          {artists.length === 0 ? (
            <p className="text-xl text-gray-base text-shadow">
              We haven&apos;t announced any artists yet, but check back soon!
            </p>
          ) : (
            <Tiles container="-ml-12 -mt-12" tile="pl-12 pt-12 w-full sm:w-1/2 lg:w-1/3">
              {artists.map((artist) => (
                <ArtistTile
                  key={artist.slug}
                  slug={artist.slug}
                  title={artist.title}
                  image={artist.featuredImage.sourceUrl}
                />
              ))}
            </Tiles>
          )}
        </PageContainer>
      </TornSection>
    </PageLayout>
  );
};

export default withApollo(ArtistsPage);
